// extracted by mini-css-extract-plugin
export default {"custom-zoom-controls":"ZoomControls_custom-zoom-controls__5ZH5j","loading-value":"ZoomControls_loading-value__L4f1E"};